export default "__VITE_ASSET__e430ea0f__"